
import { defineComponent, onActivated, onMounted, ref, watch } from "vue";
import {
  CommonDialog,
  AdminTableLayout,
  ReportTable,
} from "@/components/Common";
import { useDialogCommon, useReportTableShowColumn } from "@/hooks";
import { SendEleZtoSign } from "@/api-server/modules/defaultServer";

import { tableColumn } from "./previewSignTableColumn";
import moment from "dayjs";
import { ElMessage } from "element-plus";
import { ColumnList } from "@/@types/common";

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    CommonDialog,
    AdminTableLayout,
    ReportTable,
  },

  emits: ["update:visible", "updateSuccess"],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context);
    // const tableData = ref<BUSINESS_SERVE_PLATFORM_PC.QueryContractInfoResponseData[]>([])
    const loading = ref(false);
    const showTableColumnAll = ref<ColumnList>([]);
    const { showTableColumn } = useReportTableShowColumn(tableColumn);
    showTableColumnAll.value = showTableColumn.value.filter((v: any) => {
      if (props.formData.contractProjectName) {
        return v.prop && v.prop !== "customerName";
      }
      return v.prop && v.prop !== "contractProjectName";
    });
    // const requestTableData = async () => {
    //     loading.value = true
    //     const { data: { data }} = await QueryContractInfo.fetch({
    //       siteId: props.formData.siteId,
    //       customerId: props.formData.customerId,
    //       accountCycle: props.formData.accountCycle,
    //       borrowingDate: moment(props.formData.borrowingDate).format("YYYYMMDD"),
    //     })
    //     tableData.value = [ {...props.formData, ...data }] as BUSINESS_SERVE_PLATFORM_PC.QueryContractInfoResponseData[]
    //     loading.value = false
    // }

    const handleSure = async () => {
      await SendEleZtoSign.fetch({
        accountBillId: props.formData.id,
        contractProjectId: props.formData.contractProjectId,
        projectCustomer: props.formData.contractProjectName,
        accountName: props.formData.accountName,
        accountPhone: props.formData.accountPhone,
        accountBillType: props.formData.accountBillType,
        accountBillTypeDesc: props.formData.accountBillTypeDesc,
        billPeriodDateTime: props.formData.billPeriodDateTime,
        contractSubject: props.formData.contractSubject,
        siteId: props.formData.siteId,
        siteName: props.formData.siteName,
        customerName: props.formData.customerName,
        customerId: props.formData.customerId,
        accountCycleDay: moment(props.formData.borrowingDate).format(
          "YYYYMMDD"
        ),
        accountCycle: props.formData.accountCycle,
        billCount: props.formData.billCount,
        tranFee: props.formData.tranFee,
        claimsFee: props.formData.claimsFee,
        claimsAddFee: props.formData.claimsAddFee,
        totalFee: props.formData.totalFee,
        accountWeight: props.formData.accountWeight,
        crossSettlementFee: props.formData.crossSettlementFee,
        hexiaoFee: props.formData.hexiaoFee,
        expensesFee: props.formData.expensesFee,
      });
      ElMessage.success({ showClose: true, message: "发送电子签成功" });
      visibleRef.value = false;
      context.emit("updateSuccess");
    };

    return {
      loading,
      showTableColumnAll,
      visibleRef,
      // requestTableData,
      handleSure,
    };
  },
});
